module.exports = __webpack_public_path__ + "fonts/Barlow/Barlow-Regular_8377a297aeeea63a8d01811d2a703b5f.ttf";